// extracted by mini-css-extract-plugin
export var contentBody = "_73-9";
export var headerImage = "_73-2";
export var imageButton = "_73-7";
export var imageButtonIcon = "_73-8";
export var imageHeader = "_73-4";
export var imageHeaderText = "_73-5";
export var imageOverlay = "_73-3";
export var imageTitle = "_73-6";
export var imageWrapper = "_73-1";
export var taskList = "_73-a";
export var widget = "_73-0";